
export const API_URL = "https://rescuredemo2-c92c7df2a943.herokuapp.com/api/";
export const API_BASE = "https://rescuredemo2-c92c7df2a943.herokuapp.com/";
export const SESSION_COOKIE = "usrYRxeqsStandardDemo";

export const API_CJMED = "https://cjmedilus-47c38d92aa3d.herokuapp.com/api/";

/*
export const API_URL = "http://localhost:1023/api/";
export const API_BASE = "http://localhost:1023/";
export const SESSION_COOKIE = "YRDemsLocal";
*/

/*
design4
iiC53l39XEbC3QvX
*/

export const SMALLER_PROCESS = "https://cjmarketing.co/image_directory/loading.gif";
export const SMALL_PROCESSING = "https://api.picnick.co.za/assets/smallprocess.gif";
export const IMAGE_PROFILE = "https://newclient.cjdsa.co.za/images/base/profile.jpg";
